import { Injectable } from '@angular/core';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { Signal } from "../models/Signal";
import { SignalsConfig } from '../models/SignalsConfig';

@Injectable()
export class SignalsConfigurationService {
  private qbitiaApiUrl: string;
  private apiBoUrl: string;
  private defaultSignal: Signal;
  private qbtiaAssetProviderId: string;
  private signalsApiUrl: string;

  constructor(){
    var config: SignalsConfig = APP_SETTINGS.SignalsConfig;
    var configBo: SignalsConfig = APP_SETTINGS.SignalBoConfig;

    this.qbitiaApiUrl = config.QbitiaApiUrl;
    this.defaultSignal = config.DefaultSignal;
    this.apiBoUrl = configBo.ApiUrl;
    this.qbtiaAssetProviderId = configBo.QbitiaAssetProviderId;
    this.signalsApiUrl = config.SignalsApiUrl;
  }

  public GetQbitiaApiUrl(): string {
    return this.qbitiaApiUrl;
  };

  public GetApiBoUrl(): string {
    return this.apiBoUrl;
  };

  public GetDefaultSignal(): Signal {
    return this.defaultSignal;
  };

  public GetQbitiaAssetProviderId(): string {
    return this.qbtiaAssetProviderId;
  }
  public GetSignalsApiUrl(): string {
    return this.signalsApiUrl;
  };
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/signalsconfiguration.service.ts